import React,{ Component, Fragment } from "react";
import PropTypes from 'prop-types';

class Price extends Component{

    constructor(props) {
        super(props);
        this.state={
          isShowBag:this.props.isShowBag|| true
        }
    }
    
    render(){
      const { priceDatas,keyValue, isShowBag } = this.props;
      const { discountPrice,price,discountPer,savedAmount,discountType,isMealTypeDis,savedCouponAmount:couponSaveAmount,discountTypeCoupon:couponType, couponCode:applyCoupon,discountPriceCoupon:couponDiscount, discountPerCoupon:couponPerDiscount } =priceDatas || {};
      const CURRENCY='AED';
      const BAG_PRICE=180;
      const savedCouponAmount = (couponSaveAmount==undefined)?0:couponSaveAmount;
      const discountTypeCoupon = (couponType==undefined)?false:couponType;
      const couponCode = (applyCoupon==undefined)?false:applyCoupon;
      const discountPriceCoupon = (couponDiscount==undefined)?0:couponDiscount;
      const discountPerCoupon = (couponPerDiscount==undefined)?0:couponPerDiscount;
      const saveVal= (savedAmount!=undefined)?savedAmount+savedCouponAmount:savedCouponAmount;
      // console.log('discountPerCoupon');
      // console.log((savedCouponAmount/100));
      // console.log(savedAmount);
      return priceDatas!=undefined && <div className={"priceCon"}>
      <div className={"flexRow"}>
        {(discountPer > 0 || discountPerCoupon>0) && <Fragment>
          <p className={"discountPrice"}>{CURRENCY} {price/100}</p>
          <div className="discountOffCon">
          {price>0 && discountPrice>0 && <p className={"price"}>{CURRENCY} {discountPrice/100}</p>}
          {price>0 && discountPerCoupon>0 && discountPrice<=0 && <p className={"price"}>{CURRENCY} {discountPriceCoupon/100}</p>}
          <div className={"discountPerCon"}>
            {(isMealTypeDis==0 || isMealTypeDis==undefined && discountPer>0) && <p className={"discountPer"}>{discountType=='percent'?discountPer:(discountPer/100)}{discountType=='percent'?'%':'AED'}</p>}
            {(isMealTypeDis==0 || isMealTypeDis==undefined) && discountPerCoupon>0 && discountPrice<=0 && <p className={"discountPer"}>{discountPerCoupon}{discountTypeCoupon=='percent'?'%':' AED'}</p>}
            {isMealTypeDis>0 && <p className={"discountPer"}>{'Free Breakfast'}</p>}
            <p className={"discountPerSub"}>{(discountType=='percent' || discountTypeCoupon=='percent')?'OFF':''}</p>
          </div>
          </div>
        </Fragment>}
        {discountPer == 0 && price>0 && discountPerCoupon == 0 && <Fragment><p className={"price"}>{CURRENCY} {price/100} </p><p className={"bagPrice"}>*Discounts / Coupon Code / Vouchers Applicable at Checkout</p></Fragment>}
       {discountPerCoupon > 0 && discountPrice>0 && <div className="discountOffCon">
          {discountPrice>0 && <p className={"discountPrice"}>{CURRENCY} {discountPrice/100}</p>}
          {price>0 && discountPerCoupon>0  && <p className={"price"}>{CURRENCY} {discountPriceCoupon/100}</p>}
          <div className={"discountPerCon"}>
            {(isMealTypeDis==0 || isMealTypeDis==undefined) && discountPerCoupon>0  && <p className={"discountPer"}>{discountPerCoupon}{discountTypeCoupon=='percent'?'%':' AED'}</p>}
            <p className={"discountPerSub"}>{(discountTypeCoupon=='percent')?'OFF':''}</p>
          </div>
          </div>}
      </div>
      
      {(savedAmount>0 || savedCouponAmount>0) && <p className={"savePrice"}><span>Saved {CURRENCY} {(saveVal)/100}</span> on this order.</p>}
      {isShowBag && <p className={"bagPrice"}><span>+{BAG_PRICE} Refundable bag deposit is required </span><span>on your first order. Not applicable on renewal.</span></p>}
      {couponCode !='' && <p className={"bagPrice"}>Apply coupon code <strong>{couponCode}</strong> with {discountPerCoupon}{discountTypeCoupon=='percent'?'%':''} {(discountTypeCoupon=='percent') ?'OFF':'AED'}.</p>}
    </div>;
    }
}
Price.propTypes = {
  priceDatas: PropTypes.object.isRequired,
  isShowBag: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
    PropTypes.bool
  ]),
};
Price.defaultProps = {
  priceDatas: {},
  isShowBag:false
};
export default Price;